import { useQuery } from "@tanstack/react-query";
import { orderService } from "@shared/src/services/order.service";
import { processMerchantStats, processReviews, ReviewCounts } from "@shared/src/utils/helpers/merchant-stats";
import { MerchantStats, MerchantStatsData, ReviewStats } from "@sdk/shared/types/order.types";
import { ProcessedMerchantStats } from "@sdk/shared/lib/merchant-stats";

type ErrorResponse<T> = {
  data: T | null;
};

interface MerchantStatsResult {
  stats: ProcessedMerchantStats | undefined;
  reviews: ReviewCounts | undefined;
  isLoading: boolean;
  error: Error | null;
}

export const useMerchantStats = (address: string): MerchantStatsResult => {
  const { data, isLoading, error } = useQuery<MerchantStatsData, Error>({
    queryKey: ["merchantStats", address],
    queryFn: () => orderService.getMerchantStats(address),
    enabled: !!address,
  });

  const processedStats = data?.merchantStats ? processMerchantStats(data.merchantStats) : undefined;

  const processedReviews = data?.reviews ? processReviews(data.reviewStats) : undefined;

  return {
    stats: processedStats,
    reviews: processedReviews,
    isLoading,
    error,
  };
};
